import React from 'react';
import { useForm } from '../../contexts/FormContext';
import InputField from '../common/InputField';
import styles from './DataPribadiForm.module.css'; // Menggunakan style yang sama dengan DataPribadiForm

const KontakDaruratForm = () => {
    const { 
        formData, 
        handleChange, 
        errors 
    } = useForm();

    // Selector untuk nilai dalam nested object
    const getValue = (field) => {
        return formData.kontak_darurat ? formData.kontak_darurat[field] || '' : '';
    };

    // Handler untuk input dalam nested object
    const handleNestedChange = (e) => {
        const { name, value } = e.target;
        const fieldName = name.split('.')[1]; // Ambil nama field setelah "kontak_darurat."

        const updatedKontakDarurat = {
            ...formData.kontak_darurat,
            [fieldName]: value
        };

        // Gunakan event object tiruan untuk handler form context
        const syntheticEvent = {
            target: {
                name: 'kontak_darurat',
                value: updatedKontakDarurat
            }
        };

        handleChange(syntheticEvent);
    };

    // Helper untuk mendapatkan error message untuk field dalam nested object
    const getError = (field) => {
        const errorKey = `kontak_darurat.${field}`;
        return errors[errorKey];
    };

    const hubunganOptions = [
        { value: '', label: 'Pilih hubungan' },
        { value: 'Suami/Istri', label: 'Suami/Istri' },
        { value: 'Orang Tua', label: 'Orang Tua' },
        { value: 'Anak', label: 'Anak' },
        { value: 'Saudara', label: 'Saudara' },
        { value: 'Kerabat', label: 'Kerabat' },
        { value: 'Teman', label: 'Teman' },
        { value: 'Lainnya', label: 'Lainnya' }
    ];

    return (
        <div className={styles.container}>
            <h2 className={styles.title}>Kontak Darurat</h2>
            <p>Silakan isi informasi kontak yang bisa dihubungi dalam keadaan darurat.</p>

            <div className={styles.formSection}>
                <InputField
                    label="Nama Lengkap"
                    name="kontak_darurat.nama"
                    value={getValue('nama')}
                    onChange={handleNestedChange}
                    error={getError('nama')}
                    required
                />

                <InputField
                    label="Hubungan dengan Jamaah"
                    name="kontak_darurat.hubungan"
                    value={getValue('hubungan')}
                    onChange={handleNestedChange}
                    error={getError('hubungan')}
                    select
                    options={hubunganOptions}
                    required
                />

                <InputField
                    label="Nomor Telepon"
                    name="kontak_darurat.nomor_telepon"
                    type="tel"
                    value={getValue('nomor_telepon')}
                    onChange={handleNestedChange}
                    error={getError('nomor_telepon')}
                    placeholder="contoh: +62812xxxxx"
                    required
                />

                <InputField
                    label="Alamat"
                    name="kontak_darurat.alamat"
                    value={getValue('alamat')}
                    onChange={handleNestedChange}
                    error={getError('alamat')}
                    textarea
                    rows={3}
                />
            </div>
        </div>
    );
};

export default KontakDaruratForm;